module.exports = __webpack_public_path__ + "static/img/zhongguojingye.1f41b76f.png";